import { withIdWildcard, withWildcard } from './lib'

const SEGMENTS = {
  ROOT: '/profiles',
  CHOOSE: '/choose',
  CREATE: '/create',
  MANAGE: '/manage',
  MANAGE_CREATE: '/manage-create',
  MANAGE_EDIT: '/manage-edit',
  EDIT: '/edit',
} as const

export const PROFILES = {
  // Full paths for navigation
  ROOT: SEGMENTS.ROOT,
  CHOOSE: `${SEGMENTS.ROOT}${SEGMENTS.CHOOSE}`,
  CREATE: `${SEGMENTS.ROOT}${SEGMENTS.CREATE}`,
  MANAGE: `${SEGMENTS.ROOT}${SEGMENTS.MANAGE}`,
  MANAGE_CREATE: `${SEGMENTS.ROOT}${SEGMENTS.MANAGE_CREATE}`,

  // Dynamic paths with parameters
  edit: (id: number | string) => `${SEGMENTS.ROOT}${SEGMENTS.EDIT}/${id}`,
  manageEdit: (id: number | string) =>
    `${SEGMENTS.ROOT}${SEGMENTS.MANAGE_EDIT}/${id}`,

  // Helpers for pathname checks
  isChoose: (pathname?: string) => pathname?.includes(SEGMENTS.CHOOSE) ?? false,
  isManage: (pathname?: string) =>
    pathname?.startsWith(`${SEGMENTS.ROOT}${SEGMENTS.MANAGE}`) ?? false,

  segments: SEGMENTS,

  // Patterns for router definition (relative to /profiles)
  patterns: {
    CHOOSE: withWildcard(SEGMENTS.CHOOSE),
    CREATE: withWildcard(SEGMENTS.CREATE),
    EDIT: withIdWildcard(SEGMENTS.EDIT),
    MANAGE: withWildcard(SEGMENTS.MANAGE),
    MANAGE_CREATE: withWildcard(SEGMENTS.MANAGE_CREATE),
    MANAGE_EDIT: withIdWildcard(SEGMENTS.MANAGE_EDIT),
  },
} as const
